import PageSpinner from '../shared/page_spinner';
import Actions from '../../actions/actions';
import React, { useEffect, useMemo, useState } from 'react';
import { UserAdminDataGrid, UserAdminNoRows, UserAdminToolbar } from './components/user_admin_data_grid';
import AddIcon from '@mui/icons-material/Add';
import { useSelector } from 'react-redux';
import SearchHelper from '../../helpers/search_helper';

export const CompanyListPro = ({ companies }) => {
  const currUser = useSelector((redux) => redux.user);

  const [companiesToDisplay, setCompaniesToDisplay] = useState(companies);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (companies?.length) {
      setCompaniesToDisplay(
        SearchHelper.search(searchText, companies, ['name', 'adminEmail', 'adminName', 'coid', 'pricingProgram'])
      );
    }
  }, [companies, searchText]);

  const customToolbar = useMemo(() => {
    return UserAdminToolbar(
      'Company List',
      true,
      <button
        id="user-admin-list-add-company-button"
        className="action-primary action-alt add-item-button"
        onClick={() => {
          Actions.clearCompany();
          Actions.setRoute(`/account/company/new`);
        }}
      >
        <AddIcon className="add-item-icon" />
        Add Company
      </button>
    );
  }, []);

  if (currUser === null) {
    return <PageSpinner />;
  }

  const defaultCol = { flex: 1, sortable: true };

  const columns = [
    { field: 'name', headerName: 'Name', minWidth: 175, ...defaultCol },
    { field: 'adminName', headerName: 'Admin Name', minWidth: 200, ...defaultCol },
    { field: 'adminEmail', headerName: 'Admin Email', minWidth: 275, ...defaultCol },
    { field: 'pricingProgram', headerName: 'Pricing Tier', minWidth: 40, ...defaultCol },
    { field: 'coid', hide: true },
  ];

  return (
    <div className="user-admin-page datagrid-page" id="qa-company-list-page" style={{ height: 'calc(100vh - 115px)' }}>
      <UserAdminDataGrid
        columns={columns}
        rows={companiesToDisplay}
        hideFooter
        getRowId={(row) => row.coid}
        onCellClick={({ row }) => {
          Actions.fetchCompany(row.coid);
          Actions.setRoute(`/account/companies/${row.coid}/users?type=active`);
        }}
        components={{
          LoadingOverlay: PageSpinner,
          Toolbar: customToolbar,
          NoRowsOverlay: UserAdminNoRows,
        }}
        componentsProps={{
          toolbar: {
            value: searchText,
            clearSearch: () => setSearchText(''),
            onChange: (event) => setSearchText(event.target.value),
          },
        }}
        rowClassFunc={(row) => `qa-company-list-row-${row.name.replace(/\s/g, '')}`}
      />
    </div>
  );
};

export default CompanyListPro;
